import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider, useDispatch, useSelector } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import store, { history } from 'src/store';
import { HistoryRouter as Router } from 'redux-first-history/rr6';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history={history}>
        <React.Suspense>
          <App />
        </React.Suspense>
      </Router>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();